export default __webpack_public_path__ + "static/media/waishui.a9d2bd92.png";